<template>
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-secondary" style="width: 5rem; height: 5rem;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
import Auth from '@aws-amplify/auth';
import { Hub } from '@aws-amplify/core';
import { mapActions } from 'vuex';
import {
  CREATE_USER_IF_NOT_EXIST
} from '../../../store/modules/oauth2/constants';
import constants from '../../../_consts';
import routerConstant from '@/router/constants';

export default {
  name: 'Oauth2LoginSuccess',
  methods: {
    ...mapActions({
      createUserIfNotExist: CREATE_USER_IF_NOT_EXIST
    })
  },
  created () {
    Hub.listen('auth', data => {
      if (data.payload.event === 'signIn') {
        Auth.currentAuthenticatedUser()
          .then(user => {
            this.createUserIfNotExist({idToken: user.getSignInUserSession().getIdToken().getJwtToken()}, {skipAuthen: true}).then(response => {
              let role = response.role;
              // Save all info to local storage
              localStorage.setItem(constants.LOCAL_STORE.userId, response.userId);
              localStorage.setItem(constants.LOCAL_STORE.role, response.role);
              localStorage.setItem(constants.LOCAL_STORE.userName, response.userName);
              localStorage.setItem(constants.LOCAL_STORE.googleAPIKey, response.googleAPIKey);
              localStorage.setItem(constants.LOCAL_STORE.addOns, response.addOns);
              localStorage.setItem(constants.LOCAL_STORE.isBingMap, response.useBingMap);
              localStorage.setItem(constants.LOCAL_STORE.isShiftboardEnabled, response.isShiftboardEnabled);
              if ([constants.USER_ROLE.accountManager, constants.USER_ROLE.eventManager, constants.USER_ROLE.admin].indexOf(response.role) < 0) {
                localStorage.setItem(constants.LOCAL_STORE.clientId, response.clientId);
              } else {
                localStorage.setItem(constants.LOCAL_STORE.clientId, 0);
              }

              if ([constants.USER_ROLE.client].indexOf(response.role) < 0) {
                localStorage.setItem(constants.LOCAL_STORE.clientName, 'CHOOSE CLIENT');
              } else {
                localStorage.setItem(constants.LOCAL_STORE.clientName, response.clientName);
                // state.clientName = response.clientName;
              }
              if ([constants.USER_ROLE.clientManager, constants.USER_ROLE.accountManager, constants.USER_ROLE.eventManager, constants.USER_ROLE.admin].indexOf(role) >= 0) {
                this.$toast.success('Login successful', '', {
                  ...this.$toastOpt.optSuccess
                });
                this.$router.push('/manager');
                // this.$router.replace(constants.routeDirect.managerDashboard);
              } else if (constants.USER_ROLE.client === role) {
                this.$toast.success('Login successful', '', {
                  ...this.$toastOpt.optSuccess
                });
                // this.$router.replace(constants.routeDirect.clientDashboard);
                this.$router.push({
                  name: routerConstant.clientDashboard.name,
                  params: {
                    clientId: response.clientId
                  }
                });
              } else {
                this.$toast.error('You do NOT have permission to login', '', {
                  ...this.$toastOpt.optSuccess
                });
                Auth.signOut().then(() => {
                  console.log('logout');
                }).catch(error => console.log('error', error));
                this.doLogout().then(() => {
                  this.disconnetWM();
                  return this.$router.go('/login');
                });
              }
            });
            // this.$router.push('/afterAuth');
          })
          .catch(() => console.log('Not signed in'));
      } else {
        console.log('ELSE');
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// Oauth2LoginSuccess.vue?6572edb1